import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppStore, useAuthStore, useTrackingStore } from 'store';
import { Button } from 'components/ui/Button';
import { CardHeader } from 'components/ui/card';
import { SCREEN_TYPES } from 'utils/constants';
import { resetAllProductRelatedStores } from '../utils';
import { UserProfile } from './UserProfile';
import { LanguageToggle } from './LanguageToggle';

export default function AppHeader() {
  const { t } = useTranslation();
  const { stationId, logout } = useAuthStore();
  const { currentScreen, setCurrentScreen } = useAppStore();
  const { setCurrentTrackingId } = useTrackingStore();

  const showExitButton =
    currentScreen !== SCREEN_TYPES.APP_SELECT && currentScreen !== SCREEN_TYPES.LOGIN;
  const onExitClick = () => {
    setCurrentScreen(SCREEN_TYPES.APP_SELECT);
    resetAllProductRelatedStores();
    setCurrentTrackingId('');
  };

  return (
    <CardHeader className="flex-row items-center justify-between gap-3 space-y-0 pb-4">
      <div className="flex items-center gap-2.5">
        <UserProfile />
        <div className="min-w-0">
          <div className="text-sm text-slate-500">{stationId || ''}</div>
        </div>
      </div>
      <div className="flex items-center gap-2.5">
        {showExitButton && <Button onClick={onExitClick}>{t('header.exit')}</Button>}

        <LanguageToggle />

        <Button
          onClick={() => {
            void logout();
          }}
          variant="destructive"
          size="sm"
          className="h-10 rounded-xl px-4"
        >
          <LogOut className="h-4 w-4" />
          {t('header.logout')}
        </Button>
      </div>
    </CardHeader>
  );
}
